export default "__VITE_ASSET__1075d98f__"